export const supportContent = [
  {
    heroTitle: "24/7 Support Contracts",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "We're a Trusted Contractor That You Can Rely On",
    introText: `AquaHeat offers a comprehensive range of emergency 24/7 repair services for your home or portfolio, so you can be sure that no matter what happens help is on hand.`,
  },
  {
    contLeftTitle: "Multi Sector Experience",
    contLeftText: `We operate for corporate clients with residential PRS developments, insurance companies with large domestic portfolios.`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643110133/AquaHeat/new%20images/IMG-20210923-WA0004_czzwmn.webp`,
  },
  {
    contRightTitle: "24/7 Support",
    contRightText: `Our experienced team of engineers and tradespeople are on hand every day and night of the year to put right any disaster at your property.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643107772/AquaHeat/new%20images/Screenshot_2022-01-25_at_10.46.14_amartn.webp`,
  },
  {
    callToActionTitle: "For 24/7 Support Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
